import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface LogDataReq {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 开始时间 */
  start_time: number
  /** 结束时间 */
  end_time: number
  /** 触发结果：0-仅记录 1-提示用户卸载 2-拦截并提示用户卸载 */
  handle_type?: number
  /** 拦截类型  1:黑名单 2:白名单 */
  interval_type?: number
  /** 关键词 */
  key_word?: string
  /** 策略id */
  strategy_id?: string
  /** 终端所属分组 id（与 GroupTreeSelector 一致，-1 或不传表示不限） */
  group_id?: string
}

export interface LogData {
  /** 触发时间 */
  report_time: number
  /** 黑名单拦截类型 ：1-黑 2-白 */
  interval_type: number
  /** 软件名 */
  soft_name: string
  /** 软件版本 */
  soft_version: string
  /** 触发结果： 0-记录 1-提示用户卸载 2-隔离违规终端，并在软件卸载完成前保持提示 */
  handle_type: number
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 所属分组 */
  group_name: string
  /** 触发策略 */
  strategy_name?: string
}

export interface LogDataRes {
  list?: LogData[]
  total?: number // 总数
}

@Injectable()
export class SoftDisabledLogService {
  constructor (private http: Http) {
  }
  @ParamsClean()
  @InvokeThrottle()
  getLogData (data: LogDataReq) {
    data.start_time ||= undefined
    data.end_time ||= undefined
    return this.http.post<LogDataRes>('/softmgr/teamsoft/disable_log', data)
  }
  download (type: 0|1, options: LogDataReq, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/soft/disable-log-list-export', params, moduleName)
  }
}
